import React from "react";
import { connect } from "react-redux";
import giftbox from "../../assets/images/adventcalendar/giftbox.png";
import tunaCan from "../../assets/images/adventcalendar/tuna-can.png";
import { Actions as ADVENTCALENDARACTIONS } from "../../store/actions/adventCalendarActions";

const isBefore = new Date() < new Date(2023, 11, 1);

function CalendarBox({
						 index,
						 setCalendarModal,
						 item = null,
						 opened = false,
					 }) {
	return (
		<React.Fragment>
			{new Date().getDate() == index + 1 ?
				<div className="w-20 h-20 sm:w-32 sm:h-32 font-advent text-2xl drop-shadow-xl relative box shake"
					 onClick={() => setCalendarModal(index+1)}>
					<img src={giftbox} className="w-full h-full absolute" />
					{opened && item ? <div>
							<span className="spot-white-background" />
							<img className="absolute drop-shadow-xl spot-white-background"
								 style={{ position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }}
								 src={`https://s3.eu-central-1.amazonaws.com/downloads.buddy.hr/adventCalendar/items/${item.id}.png`} />
						</div> :
						<div className="absolute adventCalendarNumber" style={{
							position: "fixed",
							top: "50%",
							left: "50%",
							transform: "translate(-50%)",
							textShadow: "black 0px 0px 10px 10px",
							fontSize: "3rem",
						}}>
							{index + 1}
						</div>}
				</div> :
				<div className="w-20 h-20 sm:w-32 sm:h-32 font-advent text-2xl drop-shadow-xl shake relative"
					 onClick={() => isBefore && setCalendarModal(index+1)}>
					<img src={giftbox} className="w-full h-full absolute" />
					{opened && item ? <div>
							<span className="spot-white-background" />
							<img
								className="absolute drop-shadow-xl spot-white-background"
								style={{ position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }}
								src={`https://s3.eu-central-1.amazonaws.com/downloads.buddy.hr/adventCalendar/items/${item.id}.png`} />
						</div> :
						<div className="absolute adventCalendarNumber" style={{
							position: "fixed",
							top: "50%",
							left: "50%",
							transform: "translate(-50%)",
							textShadow: "black 0px 10px 10px",
							fontSize: "3rem",
						}}>
							{index + 1}
						</div>}
				</div>
			}
		</React.Fragment>
	);
}

const mapStateToProps = (state, ownProps) => {
	const currentGift = state.adventCalendar.myGifts?.find((i) => i.boxNumber == ownProps.index);
	console.log(ownProps.index, state.adventCalendar.myGifts, currentGift, state.adventCalendar.items);
	return {
		opened: !!currentGift,
		item: state.adventCalendar.items?.find(i => i.id == currentGift?.itemDonated),
	};
};

const mapDispatchToProps = dispatch => ({
	setCalendarModal: (value) => dispatch(ADVENTCALENDARACTIONS.setCalendarModal(value)),
});

export default connect(
	mapStateToProps, mapDispatchToProps,
)(CalendarBox);
